export default __webpack_public_path__ + "static/media/voice-message.f2d1e94e.svg";